import * as React from "react";
import { Toolbar, Typography } from "@material-ui/core";
import { useParams } from "react-router";
import { EarningsSummary } from "../../../../../services/earnings/types/earnings-summary";
import { getEarningsSummary } from "../../sdk/earnings";
import { EarningsSummaryComponent } from "./components/earnings-summary";
import { RoyaltiesAccount } from "../../../../../services/royalties/types/royalties-account";
import { getAccount } from "../../sdk/royalties";

export const EarningsSummaryPage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();

  const [loading, setLoading] = React.useState(false);
  const [summary, setSummary] = React.useState<EarningsSummary[]>([]);
  const [account, setAccount] = React.useState<RoyaltiesAccount>();

  React.useEffect(() => {
    setLoading(true);
    Promise.all([
      getEarningsSummary(userId).then((data) => setSummary(data)),
      getAccount(userId).then((data) => setAccount(data)),
    ]).finally(() => setLoading(false));
  }, [userId]);

  return (
    <section style={{ margin: "30px" }}>
      <Toolbar variant="dense">
        {account ? (
          <Typography variant="h4" style={{ flexGrow: 1 }}>
            {account.name} ({account.email})
          </Typography>
        ) : null}
      </Toolbar>

      <EarningsSummaryComponent
        style={{ marginTop: "20px" }}
        summary={summary}
        loading={loading}
      />
    </section>
  );
};
